import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NewAgencyComponent } from './new-agency.component';
import { NewAgencyResolve } from './new-agency.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: NewAgencyComponent,
        resolve: {
          portal: NewAgencyResolve
        }
      }
    ])
  ],
  exports: [RouterModule],
  providers: [NewAgencyResolve]
})
export class NewAgencyRoutingModule {}
